export const VENDING_ENABLED = 'vending_enabled' as const;
export const VENDING_DISABLED = 'vending_disabled' as const;
export const VENDING_READ_ONLY = 'vending_read_only' as const;

export type VendingStatus = (
  | typeof VENDING_ENABLED
  | typeof VENDING_DISABLED
  | typeof VENDING_READ_ONLY
);
